import { X, Download, RefreshCw, CheckCircle } from 'lucide-react';

interface UpdateModalProps {
  updateInfo: { version: string; releaseNotes?: string } | null;
  progress: number;
  downloaded: boolean;
  error: string | null;
  onDownload: () => void;
  onInstall: () => void;
  onClose: () => void;
}

export function UpdateModal({
  updateInfo,
  progress,
  downloaded,
  error,
  onDownload,
  onInstall,
  onClose
}: UpdateModalProps) {
  if (!updateInfo) return null;

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 480 }}>
        <div className="modal-header">
          <span className="modal-title">软件更新</span>
          <button className="icon-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div className="modal-body">
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ width: 64, height: 64, background: 'rgba(0,113,227,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              {downloaded ? (
                <CheckCircle size={32} style={{ color: '#34c759' }} />
              ) : (
                <RefreshCw size={32} style={{ color: 'var(--apple-blue)', animation: progress > 0 ? 'spin 1s linear infinite' : 'none' }} />
              )}
            </div>
            <div style={{ fontSize: 17, fontWeight: 600, color: 'var(--apple-dark)', marginBottom: 4 }}>
              发现新版本 v{updateInfo.version}
            </div>
            <div style={{ fontSize: 13, color: 'var(--apple-gray)' }}>
              {downloaded ? '更新已下载完成，点击安装后将重启应用' : '更新包下载中...'}
            </div>
          </div>

          {updateInfo.releaseNotes && (
            <div style={{ background: 'var(--apple-bg)', padding: 14, borderRadius: 8, marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--apple-mid)', marginBottom: 8 }}>更新内容</div>
              <pre style={{ fontSize: 12, color: 'var(--apple-gray)', whiteSpace: 'pre-wrap', margin: 0 }}>
                {updateInfo.releaseNotes}
              </pre>
            </div>
          )}

          {progress > 0 && !downloaded && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--apple-gray)', marginBottom: 6 }}>
                <span>下载进度</span>
                <span>{progress}%</span>
              </div>
              <div style={{ height: 6, background: 'var(--apple-separator)', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{ height: '100%', width: `${progress}%`, background: 'var(--apple-blue)', borderRadius: 3, transition: 'width 0.3s' }} />
              </div>
            </div>
          )}

          {error && (
            <div style={{ background: 'rgba(255,59,48,0.1)', padding: 12, borderRadius: 8, marginBottom: 16, color: '#ff3b30', fontSize: 13 }}>
              ⚠️ {error}
            </div>
          )}
        </div>
        <div className="modal-footer">
          {downloaded ? (
            <button className="btn-apple btn-apple-primary" onClick={onInstall}>
              <RefreshCw size={14} />
              立即安装并重启
            </button>
          ) : (
            <button className="btn-apple btn-apple-primary" onClick={onDownload} disabled={progress > 0 && progress < 100}>
              <Download size={14} />
              {progress > 0 ? `下载中... ${progress}%` : '下载更新'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
